var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAtomsIconFilledTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#196323"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M15.391 35.822c-.724 0-1.417-.295-1.913-.815L.712 21.609c-.994-1.04-.94-2.678.116-3.656 1.058-.977 2.72-.926 3.709.114l10.828 11.36L37.436 5.62c.982-1.058 2.64-1.128 3.712-.165 1.068.962 1.142 2.6.165 3.653L17.33 34.979c-.491.532-1.19.838-1.92.843h-.018z",
    transform: "translate(-808 -656) translate(570 472) translate(238 184)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAtomsIconFilledTick);
export default __webpack_public_path__ + "static/media/atoms-icon-filled-tick.b659a572deb53e587a4043ea1ecb65a9.svg";
export { ForwardRef as ReactComponent };